import type { Data } from '@repo/strapi'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import { cn } from '@/lib/styles'

interface TileIconProps {
	icon: Data.Component<'utilities.basic-image'>
	size?: 'small' | 'medium' | 'large'
	className?: string
	iconClassName?: string
}

const iconSizeClasses = {
	small: 'size-8',
	medium: 'size-12',
	large: 'size-20 md:size-25',
}

export function TileIcon({ icon, size = 'medium', className, iconClassName }: TileIconProps) {
	return (
		<div
			className={cn(
				'relative shrink-0 flex justify-start items-start self-start',
				iconSizeClasses[size],
				className,
				iconClassName,
			)}
		>
			<BasicImage component={icon} className="object-contain" fill={!iconClassName} />
		</div>
	)
}
